"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
const Collector_1 = __importDefault(require("./Collector"));
const initialize = (params) => {
    window.cc = window.cc || { event_queue: [] };
    if (typeof window !== 'undefined') {
        return new Collector_1.default(params);
    }
    // eslint-disable-next-line no-console
    console.warn('collector initialized outside of a browser environment');
    return null;
};
exports.default = {
    initialize,
};
__exportStar(require("./Event"), exports);
__exportStar(require("./Command"), exports);
